import moment from "moment";
import { POPPER_MODIFIER_TOP_BOTTOM_FLIP } from "@certa/common/constants";
import { PopperPlacements } from "@certa/catalyst/components/types";
import { DateRangePicker } from "@certa/catalyst/components/DatePicker";
import { useIntl } from "react-intl";
import { useFilterOverlay } from "../FilterOverlay/FilterOverlayContext";
import { DateRangeValues } from "@certa/types";

const DateRangeFilter = () => {
  const intl = useIntl();

  const { searchValue, setSearchValue, filterProps } = useFilterOverlay();

  const shouldDisableFutureDates = filterProps?.disableFutureDates ?? false;

  const onFilterSelect = (filter: any) => {
    const startDate =
      filter?.[0]?.startOf("day").utcOffset(0, true).format("YYYY-MM-DD") ||
      null;
    const endDate =
      filter?.[1]?.endOf("day").utcOffset(0, true).format("YYYY-MM-DD") || null;

    setSearchValue({
      [DateRangeValues.START_DATE]: startDate,
      [DateRangeValues.END_DATE]: endDate
    });
  };
  const labels: [string, string] = [
    intl.formatMessage({
      id: "mainFilterbar.startDate"
    }),
    intl.formatMessage({
      id: "mainFilterbar.endDate"
    })
  ];

  return (
    <DateRangePicker
      ariaLabel={labels}
      placeholder={labels}
      inputWidth={["12rem", "12rem"]}
      maxDate={shouldDisableFutureDates ? moment() : null}
      value={[
        searchValue?.[DateRangeValues.START_DATE]
          ? moment(searchValue[DateRangeValues.START_DATE])
          : null,
        searchValue?.[DateRangeValues.END_DATE]
          ? moment(searchValue[DateRangeValues.END_DATE])
          : null
      ]}
      onChange={onFilterSelect}
      placement={[PopperPlacements.AUTO, PopperPlacements.AUTO]}
      popperModifiers={[
        POPPER_MODIFIER_TOP_BOTTOM_FLIP,
        POPPER_MODIFIER_TOP_BOTTOM_FLIP
      ]}
    />
  );
};

export { DateRangeFilter };
